import Icon from '@mdi/react';
import { mdiTrashCanOutline } from '@mdi/js';
import Box from '@mui/material/Box';
import { FC } from 'react';
import { BASE_COLORS } from '@mgm/common/utils';
import { TMouseEvent } from '../../../../types';
import { TDeleteIcon } from '../../type';

const DeleteIcon: FC<TDeleteIcon> = ({ item, onClick, size = 0.6 }) => {
  const deleteItem = (e: TMouseEvent) => {
    e.stopPropagation();

    if (onClick) {
      onClick(item || '');
    }
  };

  return (
    <Box
      sx={{
        cursor: 'pointer',
      }}
      onClick={deleteItem}
    >
      <Icon path={mdiTrashCanOutline} color={BASE_COLORS.red} size={size} />
    </Box>
  );
};

export {
  DeleteIcon,
};
